"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedPoints = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _jsxRuntime = require("react/jsx-runtime");
const Points = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2.5rem',
  height: '2.5rem',
  borderRadius: '50%',
  background: theme.palette.offer.main,
  color: theme.palette.offer.contrastText,
  fontSize: theme.typography.overline.fontSize,
  lineHeight: 2,
  fontWeight: 'bold'
}));
const BeautyPoints = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.offer.main,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center'
}));
const FormattedPoints = ({
  children
}) => {
  const {
    culture: {
      pointsFormat
    } = {}
  } = (0, _culture.useCulture)();
  if (!pointsFormat) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Points, {
      children: children
    });
  }
  const {
    currency
  } = pointsFormat;
  if (currency === _culture.PointsCurrency.Hearts) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BeautyPoints, {
      children: [children, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.RewardsHeartsFilled, {
        fontSize: "inherit"
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Points, {
    children: children
  });
};
exports.FormattedPoints = FormattedPoints;